import { EntityStore } from '@datorama/akita';
import { Observable } from 'rxjs';
import { GeometricFormState } from './geometric-form.state';
import { GeometricFormType } from './geometric-form.type';


export abstract class GeometricFormService<T> {

  constructor(private store: EntityStore<GeometricFormState>) {
  }

  abstract get(): Observable<T[]>;

  abstract add(element: T): void;

  abstract update(id: number, element: Partial<T>): void;

  abstract remove(id: number): void;

  abstract getType(): GeometricFormType;

  updateUI(ui: GeometricFormState['ui']): void {
    this.store.update(state => ({
      ui: {
        ...state.ui,
        ...ui
      }
    }));
  }

  setActive(...ids: number[]) {
    this.store.addActive(ids);
  }

  clear() {
    this.store.remove();
  }

}
